var Direction;
(function (Direction) {
    Direction[Direction["LEFT"] = 0] = "LEFT";
    Direction[Direction["RIGHT"] = 1] = "RIGHT";
})(Direction || (Direction = {}));
var Color;
(function (Color) {
    Color[Color["RED"] = 0] = "RED";
    Color[Color["BLACK"] = 1] = "BLACK";
})(Color || (Color = {}));
function color(node) {
    return node ? node.color : Color.BLACK;
}
function getGrandParent(node) {
    if (node && node.parent) {
        return node.parent.parent;
    }
    return null;
}
function getUncle(node) {
    var grandparent = getGrandParent(node);
    if (grandparent === null || node === null) {
        return null;
    }
    return grandparent.getChild(node.parent === grandparent.left ? Direction.RIGHT : Direction.LEFT);
}
var ITNode = /** @class */ (function () {
    function ITNode(start, end, value, color) {
        if (color === void 0) { color = Color.RED; }
        this.parent = null;
        this.right = null;
        this.left = null;
        this.color = color;
        this.max = end;
        this.start = start;
        this.end = end;
        this.value = value;
    }
    ITNode.prototype.getChild = function (currentDir) {
        return currentDir ? this.right : this.left;
    };
    ITNode.prototype.setChild = function (currentDir, val) {
        this[currentDir ? 'right' : 'left'] = val;
        if (val) {
            val.parent = this;
        }
    };
    ITNode.prototype.updateMax = function () {
        this.max = this.end;
        if (this.left && this.left.max > this.max) {
            this.max = this.left.max;
        }
        if (this.right && this.right.max > this.max) {
            this.max = this.right.max;
        }
        if (this.parent) {
            this.parent.updateMax();
        }
    };
    return ITNode;
}());
var IntervalTree = /** @class */ (function () {
    function IntervalTree() {
        this.size = 0;
        this.root = null;
        this.valueMap = new Map();
    }
    IntervalTree.prototype.fixInsert = function (node) {
        // Is root or parent is Color.BLACK
        if (node.parent === null) {
            node.color = Color.BLACK;
            return;
        }
        // Fix 2
        if (color(node.parent) === Color.BLACK) {
            return;
        }
        // Fix 3
        var uncle = getUncle(node);
        var parent = node.parent;
        if (color(uncle) === Color.RED) {
            parent.color = Color.BLACK;
            uncle.color = Color.BLACK;
            var grandparent_1 = getGrandParent(node);
            grandparent_1.color = Color.RED;
            this.fixInsert(grandparent_1);
            return;
        }
        // Fix 4
        var grandparent = getGrandParent(node);
        var nodeSide = parent.right === node ? Direction.RIGHT : Direction.LEFT;
        var parentSide = grandparent.right === parent ? Direction.RIGHT : Direction.LEFT;
        if (nodeSide !== parentSide) {
            this.rotate(parent, parentSide);
            node = node.getChild(parentSide);
            parent = node.parent;
            grandparent = getGrandParent(node);
            nodeSide = parent.right === node ? Direction.RIGHT : Direction.LEFT;
        }
        // Fix 5
        parent.color = Color.BLACK;
        grandparent.color = Color.RED;
        this.rotate(grandparent, !nodeSide ? Direction.RIGHT : Direction.LEFT);
    };
    IntervalTree.prototype.rotate = function (node, direction) {
        var parent = node.parent;
        var pivot = node.getChild(!direction ? Direction.RIGHT : Direction.LEFT);
        node.setChild(!direction ? Direction.RIGHT : Direction.LEFT, pivot.getChild(direction));
        pivot.setChild(direction, node);
        if (parent) {
            parent.setChild(parent.right === node ? Direction.RIGHT : Direction.LEFT, pivot);
        }
        else {
            this.root = pivot;
            this.root.parent = null;
        }
        node.updateMax();
    };
    IntervalTree.prototype.insert = function (start, end, value) {
        if (this.valueMap.has(value)) {
            console.warn('Duplicate insert', value);
        }
        var newNode = new ITNode(start, end, value);
        if (!this.root) {
            this.root = newNode;
            this.root.color = Color.BLACK;
            this.size++;
        }
        else {
            var lastNode = this.root;
            while (true) {
                var direction = newNode.end > lastNode.end ? Direction.RIGHT : Direction.LEFT;
                var currentNode = lastNode.getChild(direction);
                if (currentNode === null) {
                    lastNode.setChild(direction, newNode);
                    this.size++;
                    break;
                }
                else {
                    lastNode = currentNode;
                }
            }
        }
        this.fixInsert(newNode);
        newNode.updateMax();
        this.valueMap.set(value, newNode);
        return newNode;
    };
    IntervalTree.prototype.fixDelete = function (node, parent) {
        if (parent === null) {
            return;
        }
        var sibling = parent.right === node ? parent.left : parent.right;
        if (color(sibling) === Color.RED) {
            parent.color = Color.RED;
            sibling.color = Color.BLACK;
            this.rotate(parent, parent.right === node ? Direction.RIGHT : Direction.LEFT);
        }
        else if (color(parent) === Color.BLACK &&
            color(sibling) === Color.BLACK &&
            color(sibling.left) === Color.BLACK &&
            color(sibling.right) === Color.BLACK) {
            sibling.color = Color.RED;
            this.fixDelete(parent, parent.parent);
        }
        else if (color(parent) === Color.RED &&
            color(sibling) === Color.BLACK &&
            color(sibling.left) === Color.BLACK &&
            color(sibling.right) === Color.BLACK) {
            sibling.color = Color.RED;
            sibling.parent.color = Color.BLACK;
        }
        else {
            if (color(sibling) === Color.BLACK) {
                if (node === parent.left &&
                    color(sibling.right) === Color.BLACK &&
                    color(sibling.left) === Color.RED) {
                    sibling.color = Color.RED;
                    sibling.left.color = Color.BLACK;
                    this.rotate(sibling, Direction.RIGHT);
                }
                else if (node === parent.right &&
                    color(sibling.left) === Color.BLACK &&
                    color(sibling.right) === Color.RED) {
                    sibling.color = Color.RED;
                    sibling.right.color = Color.BLACK;
                    this.rotate(sibling, Direction.LEFT);
                }
            }
            sibling = parent.right === node ? parent.left : parent.right;
            sibling.color = color(parent);
            parent.color = Color.BLACK;
            sibling.getChild(node === parent.left ? Direction.RIGHT : Direction.LEFT).color = Color.BLACK;
            this.rotate(parent, node === parent.right ? Direction.RIGHT : Direction.LEFT);
        }
    };
    IntervalTree.prototype.remove = function (value) {
        if (this.root === null) {
            return;
        }
        var node = this.valueMap.get(value);
        if (!node) {
            console.warn('Cannot find: ', value);
            return;
        }
        if (node.right && node.left) {
            var replacement = node.left;
            // Find Direction.RIGHT most node, Direction.RIGHT most node should have no Direction.RIGHT child
            while (true) {
                if (replacement.right === null) {
                    break;
                }
                replacement = replacement.right;
            }
            // swap in placeholder
            var placeholder = new ITNode(replacement.start, replacement.end, null, replacement.color);
            replacement.parent.setChild(replacement.parent.right === replacement, placeholder);
            placeholder.setChild(Direction.LEFT, replacement.left);
            // assign new children
            replacement.setChild(Direction.LEFT, node.left);
            replacement.setChild(Direction.RIGHT, node.right);
            replacement.color = node.color;
            if (node.parent) {
                node.parent.setChild(node.parent.right === node, replacement);
            }
            else {
                this.root = replacement;
                this.root.parent = null;
            }
            // node placeholder is the new deletion target
            node = placeholder;
        }
        var child = node.right || node.left;
        if (node.parent) {
            node.parent.setChild(node.parent.right === node, child);
        }
        else {
            this.root = child;
            // if (this.size > 1) {
            //     this.root.parent = null;
            // }
        }
        if (color(node) === Color.BLACK) {
            if (color(child) === Color.RED) {
                child.color = Color.BLACK;
            }
            else {
                this.fixDelete(child, node.parent);
            }
        }
        if (this.size > 1) {
            (child || node.parent).updateMax();
        }
        this.valueMap.delete(value);
        this.size--;
    };
    // TODO: Deal with open and closed intervals
    IntervalTree.prototype.search = function (start, end) {
        var results = [];
        function searchRecursive(node) {
            if (!node || start > node.max) {
                return;
            }
            if (node.left !== null) {
                searchRecursive(node.left);
            }
            if (node.start < end && node.end > start) {
                results.push([node.start, node.end, node.value]);
            }
            if (node.right !== null) {
                searchRecursive(node.right);
            }
        }
        searchRecursive(this.root);
        return results;
    };
    IntervalTree.prototype.copy = function (valueCopier) {
        if (valueCopier === void 0) { valueCopier = function (v) { return v; }; }
        // Build copy with same values
        var newTree = new IntervalTree();
        newTree.size = this.size;
        newTree.root = copyRecursive(this.root);
        function copyRecursive(original, copyParent) {
            if (copyParent === void 0) { copyParent = null; }
            if (original === null) {
                return null;
            }
            var copy = new ITNode(original.start, original.end, valueCopier(original.value));
            copy.color = original.color;
            copy.max = original.max;
            copy.parent = copyParent;
            newTree.valueMap.set(copy.value, copy);
            if (original.left) {
                copy.left = copyRecursive(original.left, copy);
            }
            if (original.right) {
                copy.right = copyRecursive(original.right, copy);
            }
            return copy;
        }
        return newTree;
    };
    IntervalTree.prototype.visit = function (visitor) {
        visitRecurse(this.root);
        function visitRecurse(node) {
            if (node === null) {
                return;
            }
            visitRecurse(node.left);
            visitor(node.value, node.start, node.end);
            visitRecurse(node.right);
        }
    };
    return IntervalTree;
}());

export default IntervalTree;
//# sourceMappingURL=rb-interval-tree.es5.js.map
